import { useState } from 'react';
import { Container, Row, Col, Carousel } from "react-bootstrap";
const HomeCarousel = () => {
  const carouselItems = [
    {
      image: "./images/1.jpg",
      label: "First slide label",
      description: "Nulla vitae elit libero, a pharetra augue mollis interdum. Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
    {
      image: "./images/2.jpg",
      label: "Second slide label",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
    },
    {
      image: "./images/3.jpg",
      label: "Third slide label",
      description: "Praesent commodo cursus magna, vel scelerisque nisl consectetur."
    }
  ];
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <Container className="p-0">
      <Row>
        <Col md={12} className="p-0">
          <Carousel activeIndex={index} onSelect={handleSelect}>
            {carouselItems.map((item, idx) => (
              <Carousel.Item key={idx}>
                <img
                  className="d-block w-100"
                  src={item.image}
                  alt={`Slide ${idx + 1}`}
                />
                {/* <Carousel.Caption>
                  <h1>{item.label}</h1>
                  <p>{item.description}</p>
                </Carousel.Caption> */}
              </Carousel.Item>
            ))}
          </Carousel>
        </Col>
      </Row>
    </Container >
  );
}

export default HomeCarousel;